import { setShowClientContactModal } from '../State/showClientContactModal';
import { clearClientContactForEdit } from '../State/clientConactForEdit';

export default () => async (dispatch) => {
  
  dispatch(setShowClientContactModal(false))
  dispatch(clearClientContactForEdit())
}